import { httpClient as http } from '@/utils/http'
import type {
  ApiResponse,
  PageResponse,
  BatchDeleteRequest,
  SurchargeAirPageRequest,
  SurchargeAirListVO,
  SurchargeAirVO,
  SurchargeAirSaveRequest,
  SurchargeAirUpdateRequest
} from './types'

// 分页查询空运附加费
export const page = (params: SurchargeAirPageRequest) => {
  return http.post<PageResponse<SurchargeAirListVO>>('/price/surcharge/air/page', params)
}

// 新增空运附加费
export const save = (params: SurchargeAirSaveRequest) => {
  return http.post<boolean>('/price/surcharge/air/save', params)
}

// 修改空运附加费
export const update = (params: SurchargeAirUpdateRequest) => {
  return http.post<boolean>('/price/surcharge/air/update', params)
}

// 获取空运附加费详情
export const get = (id: string) => {
  return http.post<ApiResponse<SurchargeAirVO>>('/price/surcharge/air/get', { id })
}

// 批量上架空运附加费
export const batchOnline = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/surcharge/air/batch-online', params)
}

// 批量下架空运附加费
export const batchOffline = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/surcharge/air/batch-offline', params)
}

// 批量删除空运附加费
export const batchDelete = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/surcharge/air/delete', params)
}

// 查询冲突候选空运附加费
export const queryConflictCandidates = (params: SurchargeAirVO) => {
  return http.post<SurchargeAirVO[]>('/price/surcharge/air/queryConflictCandidates', params)
}
